import { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import styles from './Banner.module.css';

export default function Banner({ images, title, subtitle }) {
  const [indice, setIndice] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const proximaImagem = useCallback(() => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setIndice((prev) => (prev + 1) % images.length);
  }, [images.length, isTransitioning]);

  const imagemAnterior = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setIndice((prev) => (prev - 1 + images.length) % images.length);
  };
  
  const handleTransitionEnd = () => {
    setIsTransitioning(false);
  };

  useEffect(() => {
    const intervalo = setInterval(() => {
      proximaImagem();
    }, 6000);

    return () => clearInterval(intervalo);
  }, [proximaImagem]);

  return (
    <section className={styles.banner}>
      <div className={styles.slidesContainer}>
        {images.map((img, i) => (
          <div
            key={i}
            className={`${styles.slide} ${i === indice ? styles.slideActive : ''}`}
            onTransitionEnd={handleTransitionEnd}
          >
            <img
              src={img.src}
              alt={img.alt}
              className={styles.imagem}
            />
            <div className={styles.overlay} />
          </div>
        ))}
      </div>

      <div className={styles.conteudoWrapper}>
        <div className={styles.textoCentralizado}>
          <div className={styles.preTitle}>
            <div className={styles.line}></div>
            <span>O Berço imortal da poesia</span>
            <div className={styles.line}></div>
          </div>
          
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>
          
          <div className={styles.actions}>
            <Link to="/pontos-turisticos" className={styles.primaryButton}>
              Ver Pontos Turísticos
            </Link>
            <Link to="/autores" className={styles.secondaryButton}>
              Ver nossos autores
            </Link>
          </div>
        </div>
      </div>

      <div className={styles.controles}>
        <div className={styles.controlsInternal}>
          <div className={styles.buttons}>
            <button
              className={styles.botao}
              onClick={imagemAnterior}
              aria-label="Imagem anterior"
            >
              <ChevronLeft size={24} strokeWidth={1.5} />
            </button>
            <button
              className={styles.botao}
              onClick={proximaImagem}
              aria-label="Próxima imagem"
            >
              <ChevronRight size={24} strokeWidth={1.5} />
            </button>
          </div>
          
          <div className={styles.indicadores}>
            {images.map((_, i) => (
              <button
                key={i}
                className={`${styles.indicador} ${i === indice ? styles.indicadorAtivo : ''}`}
                onClick={() => {
                  if (i !== indice && !isTransitioning) {
                    setIsTransitioning(true);
                    setIndice(i);
                  }
                }}
                aria-label={`Ir para a imagem ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
